<template>
    <div>
      <observer :observerUser="user"></observer>
    </div>
  </template>

<script>
import apiClient2 from '@/services/axios/v2'
import observer from '@/components/custom/observer'
import { ToastFire } from '@/services/utilities/swal'
import { showErrorMessage } from '@/services/utilities'

export default {
  name: 'observationsCreate',
  components: {
    observer,
  },
  data() {
    return {
      user: {},
    }
  },
  created() {
    apiClient2.get(`/observations/users/${this.$route.params.userObserved}`).then(response => {
      this.user = response.data.data
    }).catch(error => {
      this.$router.go(-1)
      ToastFire('warning', showErrorMessage(error))
    })
  },
}
</script>

  <style></style>
